export const CSS = {
	container: 'c-VectorInput',
	inputs: 'c__VectorInput__inputs',
	error: 'c-VectorInput__error',
	leftInput: 'c-VectorInput__leftInput',
	rightInput: 'c-VectorInput__rightInput',
	MDL: {
		error: 'mdl-textfield__error',
	},
};

export const Style = {
	[CSS.container]: {
		display: 'block',
	},
	[CSS.inputs]: {
		flex: 1,
		display: 'flex',
		'justify-content': 'space-between',
		[`& .${CSS.leftInput}`]: {
			width: '60%',
		},
		[`& .${CSS.rightInput}`]: {
			width: '40%',
		},
	},
	[CSS.error]: {
		visibility: 'visible',
		position: 'relative',
	},
};
